import axios from 'axios';
import React, { useState } from 'react';
import styled from 'styled-components';
import moment from '../../../utils/MomentConst';

import ReactTooltip from 'react-tooltip';
import { NotificationManager } from 'react-notifications';

import { Flex, Button, Text } from '../../../components';

import Key from '../../../assets/Key.png';
import Box from '../../../assets/Box.png';
import Calendar from '../../../assets/Calendar.png';
import CalendarTopUp from '../../../assets/CalendarTopUp.png';
import Tag from '../../../assets/Tag.png';

import Eye from '../../../assets/Eye.png';
import Copy from '../../../assets/Copy.png';

const Container = styled(Flex)`
  padding: 40px;
  background: #161930;
  border-radius: 8px;
`;

const InfoContainer = styled(Container)`
  display: grid;
  align-items: center;
  justify-items: center;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 40px;
`;

const InfoIcon = styled.img`
  height: 36px;
`;

const ImgButton = styled.img`
  cursor: pointer;
`;

const Input = styled.input`
  background: #202441;
  border: solid 1px transparent;
  outline: 0;
  height: 48px;
  padding: 0 16px;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
  flex-grow: 1;
  &:focus {
    border: solid 1px #fff;
  }
`;

const LicenseBoard = (props) => {

  const [licenseValue, setLicenseValue] = useState('');

  const copyLicense = () => {
    navigator.clipboard.writeText(props.licenseData.license.key)
    NotificationManager.success('Copied License', '');
  };

  const revealLicense = () => {
    props.updateLicenseReveal(!props.licenseRevealed);
  };

  const handlePrepayrequest = () => {
    if (confirm('Are you sure you want to request a pre-payment checkout link ?')) {
      axios
        .get('/api/dashboard/user/generate-pre-payment')
        .then(res => {
          if (res.data.checkout_url) {
            window.location.replace(res.data.checkout_url);
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  }


  const submitLicense = () => {
    props.startSpinner();
    axios
      .post('/api/dashboard/license/bind?key=' + licenseValue)
      .then(res => {
        if (res.data.licenseData) {
          if (res.data.licenseData.license) {
            props.onLicenseSubmit(res.data.licenseData);
            props.stopSpinner();
            ReactTooltip.rebuild();
            NotificationManager.success('Binded License', '');
          } else {
            props.stopSpinner();
            NotificationManager.error('Invalid License', '');
          }
        }
      })
      .catch(err => {
        console.error(err);
      });
  }

  const renderInfoSection = () => {
    if (props.hasLicense) {
      return (
        <>
          <Flex dir="column">
            <InfoIcon src={Key} alt="" />
            <Flex h="18px" />
            <Text.Body size="12" weight="600" color="#7178b2">
              License Key
            </Text.Body>
            <Flex h="12px" />
            <Flex dir="row" align="center">
              <Text.Body size="12" weight="700" color="#fff">
                {props.licenseRevealed ? props.licenseData.license.key : "************"}
              </Text.Body>
              <Flex w="10px" />
              <ImgButton onClick={revealLicense} src={Eye} alt="" />
              <Flex w="10px" />
              <ImgButton onClick={copyLicense} src={Copy} alt="" />
            </Flex>
          </Flex>
          <Flex dir="column">
            <InfoIcon src={Box} alt="" />
            <Flex h="18px" />
            <Text.Body size="12" weight="600" color="#7178b2">
              Membership Type
            </Text.Body>
            <Flex h="12px" />
            <Text.Body size="12" weight="700" color="#fff">
              {props.licenseData.licenseType.name}
            </Text.Body>
          </Flex>
          <Flex dir="column">
            {
              props.licenseData.license.cancelsAt == null || props.licenseData.license.force_no_renew == 1 ?
                <InfoIcon src={Calendar} alt="" /> : <InfoIcon src={CalendarTopUp} onClick={() => handlePrepayrequest()} alt="" />
            }
            <Flex h="18px" />
            <Text.Body size="12" weight="600" color="#7178b2">
              {props.licenseData.license.force_no_renew == 0 ? 'Renewal Date' : 'Expiring Date'}

            </Text.Body>
            <Flex h="12px" />
            <Text.Body size="12" weight="700" color="#fff">
              {
                props.licenseData.license.cancelsAt == null ? "N/A" :
                  moment(props.licenseData.license.cancelsAt).format('MMMM D, YYYY')
              }
            </Text.Body>
          </Flex>
          <Flex dir="column">
            <InfoIcon src={Tag} alt="" />
            <Flex h="18px" />
            <Text.Body size="12" weight="600" color="#7178b2">
              Renewal Price
            </Text.Body>
            <Flex h="12px" />
            <Text.Body size="12" weight="700" color="#fff">
              {props.licenseData.licenseType.label}
            </Text.Body>
          </Flex>
        </>
      );
    } else {
      return (
        <Flex w="100%" dir="column">
          <Text.Body>License Key</Text.Body>
          <Flex h="24px" />
          <Flex w="100%">
            <Input
              onChange={(e) => setLicenseValue(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  submitLicense();
                }
              }}
              placeholder="Enter license"
            />
            <Flex w="16px" />
            <Button style={{ height: 48, fontSize: 14 }} bg="#F32FE0" onClick={submitLicense}>Activate License</Button>
          </Flex>
        </Flex>
      );
    }

  }

  return (
    <InfoContainer>
      {renderInfoSection()}
    </InfoContainer>
  );
};

export default LicenseBoard;
